import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, Copy } from "lucide-react";
import { toast } from "sonner";

export const FormSuccess = ({ title, message, refId, onReset, testid, emphasizeRef = false }) => {
  const copy = () => {
    if (!refId) return;
    navigator.clipboard?.writeText(refId);
    toast.success("Confirmation number copied.");
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="border border-softgray bg-white p-8 md:p-10"
      data-testid={testid}
    >
      <div className="h-12 w-12 rounded-sm bg-navy/5 flex items-center justify-center mb-6">
        <CheckCircle2 className="h-7 w-7 text-teal" />
      </div>
      <h3 className="font-heading text-2xl font-bold text-navy">{title}</h3>
      <p className="mt-3 text-charcoal/75 leading-relaxed">{message}</p>

      {refId && emphasizeRef && (
        <div className="mt-6 rounded-lg border border-navy/20 bg-offwhite p-5" data-testid="confirmation-box">
          <div className="label-caps text-navy">Your confirmation number</div>
          <div className="mt-2 flex items-center justify-between gap-4">
            <span className="font-heading text-2xl md:text-3xl font-black text-navy tracking-tight" data-testid="confirmation-number">{refId}</span>
            <button onClick={copy} className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-gold-deep transition-colors" data-testid="confirmation-copy">
              <Copy className="h-4 w-4" /> Copy
            </button>
          </div>
          <p className="mt-3 text-sm text-charcoal/70">Save this number. You can use it any time on the Partners page to check this referral's status.</p>
        </div>
      )}

      {refId && !emphasizeRef && (
        <p className="mt-4 text-sm text-slate">
          Reference: <span className="font-semibold text-charcoal">{refId}</span>
        </p>
      )}

      {onReset && (
        <button onClick={onReset} className="mt-6 label-caps text-navy hover:text-gold-deep transition-colors" data-testid="form-reset-btn">
          Submit another response
        </button>
      )}
    </motion.div>
  );
};

export default FormSuccess;
